import { useQuery } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface CustomerSerialInfo {
    cost_info: string[];
    customer_info: string[];
    delivery_info: string[];
    order_info: string[];
    rider_info: string[];
}

export const useGetExpressCustomerSerial = ({ serial_number, enabled = true }: { serial_number: string; enabled?: boolean }) => {
    return useQuery({
        queryKey: ["useGetExpressCustomerSerial"],
        queryFn: async () => {
            const response = await axiosInstance.get<{ statusCode: number; message: string; data: CustomerSerialInfo }>(
                `${enum_api_uri.express_customer_order}/${serial_number}`,
            );
            return response.data.data;
        },
        enabled,
        retry: false,
        placeholderData: prev => prev,
    });
};
